'use client';

import { Locale } from '@/enums/locale.enum';
import { usePathname } from 'next/navigation';
import { cn } from '@/lib/utils';



interface ComponentProps {
  lang: Locale;
  src?: 'layout' | 'landing' | 'side' | 'header';
  className?: string;
}



export default function LangSelect(props: ComponentProps) {
  const { lang, src } = props;
  const pathName = usePathname();

  const links = [
    { en: '/', it: '/' },
    { en: '/about', it: '/chi-siamo' },
    { en: '/project', it: '/progetto' },
    { en: '/contacts', it: '/contattaci' },
  ];

  function setLang(targetLang: Locale) {
    if (!pathName) return;

    // remove the current locale prefix (e.g., /it/... → /...)
    const withoutLocale = pathName.replace(/^\/(en|it)/, '');

    // find matching route
    const current = links.find((l) => l[lang] === withoutLocale);
    const newPath = current ? current[targetLang] : withoutLocale;

    // redirect preserving structure: /{locale}/{path}
    window.location.href = `/${targetLang}${newPath}`;
  }

  return (
    <ul
      className={cn(
        'grid grid-cols-2 auto-rows-fr auto-cols-fr',
        { 'flex-col gap-1': src === 'side' },
        props.className
      )}
    >
      {Object.values(Locale).map((locale, index) => (
        <li
          key={index}
          onClick={() => setLang(locale)}
          className={cn(
            'cursor-pointer px-2 text-[20px] leading-[120%] sm:text-[12.43px] sm:leading-[120%] sm:align-middle tracking-normal',
            { 'font-bold': locale === lang },
            {
              'border-r-[0.75px] border-white':
                index < Object.values(Locale).length - 1 && src !== 'side',
            }
          )}
        >
          {locale.toUpperCase()}
        </li>
      ))}
    </ul>
  );
}